import { render } from "./FieldsetAvatar.vue?vue&type=template&id=0f6add38&ts=true"
import script from "./FieldsetAvatar.vue?vue&type=script&lang=ts"
export * from "./FieldsetAvatar.vue?vue&type=script&lang=ts"

import "./FieldsetAvatar.vue?vue&type=style&index=0&id=0f6add38&lang=stylus"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__